module.exports = __webpack_public_path__ + "img/Atrebol.17ca9f77.png";